pageId = 'feishu-logins-new'
page = '#' + pageId

$ ->
  $page = $(page)
  $feishuSigninForm = $page.find '.feishu-signin-form'
  if $feishuSigninForm.length > 0
    tower.initMobileVerification $feishuSigninForm

